import { getTranslatedText } from '@nile/components';
import { getApiMethodAndKeyNames, apiResolver, RMMClient } from '@nile/graphql';
import { GET_WORKSTATION_LIST } from '@nile/rmm/src/modules/asset-management/Graphql/asset';

function getQuery(item) {
  switch (item.name) {
    case 'asset.name':
      return GET_WORKSTATION_LIST;
    default:
      break;
  }
}

/**
 * @description This method gets triggered on selecting a particular alert attribute
 * Responsible to return the accessKey based on the selected alert attribute
 * @return {string} - accessKey
 */
function getNameKey(item) {
  switch (item) {
    case 'asset.name':
      return 'getWorkStationList';
    default:
      break;
  }
}

function getPropValues(item, operator, allOperators, intl) {
  if (item?.name) {
    let query = apiResolver.Alert[item.name]?.api;
    let client = apiResolver.Alert[item.name]?.client;

    let variables = {};

    switch (item.name) {
      case 'policy.name':
        variables = {};
        break;
      case 'client.name':
        variables = {
          listInfo: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        };
        break;
      default:
        variables = {};
        break;
    }
    if (query && client) {
      return client.query({
        query: query,
        variables: variables
      });
    }
    if (operator) {
      return allOperators.getRuleBuilderOperators.operator_placeholders[
        operator
      ].map((el) => {
        return {
          ...el,
          label: getTranslatedText(intl, el.key),
          value: getTranslatedText(intl, el.key),
          name: el.key
        };
      });
    }
    return { client: RMMClient, query: getQuery(item) };
  }
  return {};
}

const fetchValuesFromNestedProperties = (data) => {
  const { allValues, method, nestedKey, accessKey } = data;
  return allValues.data
    ? allValues.data[method][nestedKey].map((el) => {
        return {
          name: el[accessKey],
          value: el[accessKey],
          label: el[accessKey]
        };
      })
    : [];
};

async function onAlertAttributeSelect(params) {
  const { item: field, operator, fields, allOperators, intl } = params;

  const allFields = fields;
  const selectedField = allFields.find((el) => el.name === field);
  if (selectedField.name === 'asset.name') {
    return getPropValues(selectedField, null, allOperators);
  }
  if (selectedField.dataType === 'boolean') {
    return [
      {
        name: 'true',
        label: 'true',
        value: true
      },
      {
        name: 'false',
        label: 'false',
        value: false
      }
    ];
  }
  if (selectedField.name === 'status') {
    return [
      {
        label: 'Open',
        name: 'Open',
        value: 'Open'
      },
      {
        label: 'Resolved',
        name: 'Resolved',
        value: 'Resolved'
      }
    ];
  }
  let allValues = await getPropValues(
    selectedField,
    operator,
    allOperators,
    intl
  );
  let res = [];
  const apiMethodAndKeyNames = getApiMethodAndKeyNames('Alert');

  if (selectedField?.name) {
    let method = apiMethodAndKeyNames[selectedField.name]?.method;
    let key = apiMethodAndKeyNames[selectedField.name]?.key;
    if (selectedField.nestedTo) {
      let nestedProp = apiMethodAndKeyNames[selectedField.name]?.nestedKey;
      allValues.data[method].forEach((el) => {
        if (el[[nestedProp]]) {
          res = res.concat(
            el[[nestedProp]].map((c) => {
              return {
                name: c[key],
                value: c[key],
                label: c[key]
              };
            })
          );
        }
      });
    } else {
      if (method === 'getClientList') {
        const data = {
          allValues,
          method,
          nestedKey: apiMethodAndKeyNames[selectedField.name].nestedKey,
          accessKey: key
        };
        res = fetchValuesFromNestedProperties(data);
      } else if (method === 'getClientSiteList') {
        const data = {
          allValues,
          method,
          nestedKey: apiMethodAndKeyNames[selectedField.name].nestedKey,
          accessKey: key
        };
        res = fetchValuesFromNestedProperties(data);
      } else if (operator === 'on') {
        res = allValues;
      } else {
        res = allValues.data
          ? allValues.data[method].map((el) => {
              return {
                name: key ? el[key] : el,
                value: key ? el[key] : el,
                label: key ? el[key] : el
              };
            })
          : [];
      }
    }
  }

  return res;
}

/**
 * This method is called for autocomplete fields.
 * Usually apis will be called when we choose attributes. But for autocomplete,
 * on typing few characters, api will be called. This is the method.
 * @param {object} client
 * @param {gql} query
 * @param {object} params
 */
const onAlertAttributeValueSearch = async (client, query, params) => {
  console.log('fetching values', client, query, params);
  const attribute =
    params.field.split('.').length > 1
      ? params?.field?.split('.')[1]
      : params.field;
  const nameKey = getNameKey(params.field);

  let variables = {
    listInfo: {
      condition: {
        joinOperator: 'AND',
        operands: [
          {
            attribute: attribute || 'firstName',
            operator: 'contains',
            value: params.inputValue
          }
        ]
      }
    }
  };

  const res = await client.query({
    query: query,
    variables
  });

  let allOptions = [];

  if (nameKey === 'getWorkStationList') {
    allOptions = res?.data?.[nameKey]
      ? res.data[nameKey].assets.map((el) => {
          return {
            name: `${el[attribute]}`,
            value: `${el[attribute]}`,
            label: `${el[attribute]}`
          };
        })
      : [];
  } else {
    allOptions = res?.data?.[nameKey]
      ? res.data[nameKey].map((el) => {
          return {
            name: `${el[attribute]}`,
            value: `${el[attribute]}`,
            label: `${el[attribute]}`
          };
        })
      : [];
  }

  console.log(allOptions);
  return allOptions;
};

export { onAlertAttributeSelect, onAlertAttributeValueSearch };
